import { useEffect } from "react";

const DEFAULT_OG_IMAGE =
  "https://customer-assets-jt897jd0.emergentagent.net/job_strategy-execution-5/artifacts/4039hvev_file_00000000db748206ad12262597ee8fe7.png";

// Lightweight SEO/meta manager (no external dependency).
export const Seo = ({ title, description, image }) => {
  useEffect(() => {
    if (title) document.title = title;
    const ogImage = image || DEFAULT_OG_IMAGE;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    // canonical + og:url per route (pinned to production domain)
    const canonical = "https://govxnigeria.com" + window.location.pathname.replace(/\/$/, "") || "https://govxnigeria.com/";
    const url = canonical === "https://govxnigeria.com" ? "https://govxnigeria.com/" : canonical;
    setMeta("property", "og:url", url);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, image]);

  return null;
};
